import Vue from 'vue'
import Vuex from 'vuex'
import VeeValidate from 'vee-validate'

Vue.use(Vuex);
require('es6-promise').polyfill();
Vue.use(VeeValidate);

//Separate Module States
import session from './modules/session'
import events from './modules/events'
import contents from './modules/contents'
import experts from './modules/experts'
import plans from './modules/plans'
import corporations from './modules/corporations'
import configurations from './modules/configurations'
import gifts from './modules/gifts'
import testimonials from './modules/testimonials'
import greetings from './modules/greetings'
import articles from './modules/articles'
import faqsections from './modules/faqsections'
import faqs from './modules/faqs'
import messages from './modules/messages'
import quotes from './modules/quotes'
import funnies from './modules/funnies'
import persons from './modules/persons'
import charities from './modules/charities'
import press from './modules/press'
import playlists from './modules/playlists'
import trendingPlaylists from './modules/trendingPlaylists'
import pinned from './modules/pinned'
import logos from './modules/logos'
import accounts from './modules/accounts'
import resources from './modules/resources'
import parentCorporations from './modules/parentCorporations'
import groups from './modules/groups'
/****** leave it here to prototype new store modules easily *******/
import test from './modules/test'
import podcasts from './modules/podcasts'

// initializing app store.
export default new Vuex.Store({
    state: {
        loading: false
    },
    getters: {
        isLoading: state => state.loading
    },
    actions: {
        TOGGLE_LOADING({commit}, boolean){
            commit('TOGGLE_LOADING', boolean);
        }
    },
    mutations: {
        TOGGLE_LOADING (state, value) {
            state.loading = value;
        }
    },
    modules: {
        session,
        events,
        contents,
        experts,
        plans,
        corporations,
        configurations,
        gifts,
        testimonials,
        greetings,
        articles,
        faqsections,
        faqs,
        funnies,
        messages,
        quotes,
        persons,
        charities,
        press,
        playlists,
      pinned,
      logos,
      accounts,
      resources,
      trendingPlaylists,
      parentCorporations,
      groups,
      podcasts
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js